import React from 'react';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50 pt-24 pb-12 px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-100">
        {/* Header Section */}
        <div className="bg-gradient-to-r from-emerald-600 to-teal-700 py-12 px-8 text-center">
          <h1 className="text-4xl font-extrabold text-white mb-4 tracking-tight">
            Privacy Policy
          </h1>
          <p className="text-emerald-50 text-lg opacity-90">
            Effective Date: {new Date().toLocaleDateString()}
          </p>
        </div>

        {/* Content Section */}
        <div className="p-8 md:p-12 text-slate-700 leading-relaxed space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-sm font-bold">01</span>
              Information Collection
            </h2>
            <p>
              We value your privacy and are committed to protecting your personal information. When you use our services, we may collect certain information to provide a better experience. This includes data you provide during registration or through website interactions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-sm font-bold">02</span>
              Usage of Information
            </h2>
            <p>
              The information collected is used exclusively for providing and improving our services, personalizing your experience, and communicating important updates related to your account or our offerings.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-sm font-bold">03</span>
              Data Protection
            </h2>
            <p>
              Your data is never shared with third parties without your explicit consent, except as required by law. We implement industry-standard security measures, including encryption and secure servers, to safeguard your information from unauthorized access.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-sm font-bold">04</span>
              Cookies & Tracking
            </h2>
            <p>
              Our website uses cookies to enhance the user experience, track usage patterns, and remember your preferences. You can manage cookie settings through your browser, although some features may be limited if cookies are disabled.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-sm font-bold">05</span>
              Your Rights
            </h2>
            <p>
              You have the right to access, modify, or delete your personal data at any time. If you wish to exercise these rights or have concerns about your privacy, please contact our support team directly.
            </p>
          </section>

          <div className="pt-8 border-t border-slate-100">
            <p className="text-sm text-slate-500 italic">
              * We may update this policy periodically. Continued use of the website indicates acceptance of the most current terms. We are committed to complying with all applicable data protection regulations.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
